import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCapturedTextCreated.meta';

export type UseTrackCapturedTextCreatedParams = {
  text_id: string;
  text: string;
};

export const useTrackCapturedTextCreated = () => {
  const { track } = useAnalyticsUtilities();

  const trackCapturedTextCreated = useCallback(
    (params: UseTrackCapturedTextCreatedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCapturedTextCreated };
};
